var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "upDataIDQr" }, [
    _c("em", { staticClass: "backQr" }),
    _c("div", { staticClass: "upDataIDQrDiv" }, [
      _vm._m(0),
      _c("div", { staticClass: "QRDiv" }, [
        _c("div", { ref: "qrCodeUrl", attrs: { id: "qrcode" } }),
      ]),
      _c("p", { staticClass: "describe" }, [
        _vm._v("请扫描上方二维码上传身份证"),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "upDataIDQrTitle" }, [
      _c("p", [_vm._v("登录成功")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }